import { useState } from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { Table, TableColumn } from '@zep/ui';
import { ZEM_HISTORY_TYPE } from '../../../../../libs/service/apis/src/zem-history';
import Empty from '../../components/service/common/Empty';
import { useDonations } from '../../services';
import { Donation } from '../../types/DonationTypes';
import { getDonationHistoryAmountSign, getDonationHistoryDetail, getDonationHistoryRowKey, getDonationHistoryTypeTranslationKey } from './donationHistoryPresentation';
import S from './Donations.module.scss';
const DONATION_TYPE_ZEM = '0';
export const DonationsPageView = () => {
  const {
    t
  } = useTranslation(['manage', 'wearables']);
  const [page, setPage] = useState(1);
  const {
    data: donationData
  } = useDonations(DONATION_TYPE_ZEM, page, 10);
  const columns: TableColumn<Donation>[] = [{
    title: t('manage:zem_history_table_type'),
    dataIndex: 'historyType',
    width: '18%',
    render: item => [t(getDonationHistoryTypeTranslationKey(item)), item.historyType === ZEM_HISTORY_TYPE.DONATION_RECEIVED ? item.donateType : null].filter(Boolean).join(' · ')
  }, {
    title: t('manage:zem_history_table_detail'),
    width: '27%',
    render: item => {
      const detail = getDonationHistoryDetail(item);
      return detail.translationKey ? t(detail.translationKey, {
        defaultValue: detail.defaultValue
      }) : detail.text;
    }
  }, {
    title: t('manage:donate_table_amount'),
    dataIndex: 'amount',
    width: '18%',
    render: item => `${getDonationHistoryAmountSign(item)}${item.amount.numberFormat()} ZEM`
  }, {
    title: t('manage:donate_table_spacename'),
    width: '20%',
    render: item => item.historyType === ZEM_HISTORY_TYPE.CHARGE ? '-' : item.spaceName || '-'
  }, {
    title: t('manage:donate_table_time'),
    dataIndex: 'createdAt',
    width: '17%',
    render: item => {
      const createdAt = new Date(item?.createdAt);
      createdAt.setMinutes(createdAt.getMinutes() - createdAt.getTimezoneOffset());
      return format(createdAt, 'yyyy-MM-dd aa hh:mm:ss');
    }
  }];
  return <section className="contents" data-sentry-component="DonationsPageView" data-sentry-source-file="donations.tsx">
      <div className="container">
        <h3 className={S.title}>{t('manage:zem_history_title')}</h3>
        <div className={S.table_container}>
          {donationData?.donations.length ? <Table columns={columns} data={donationData.donations} rowKey={getDonationHistoryRowKey} pagination={{
          nowPageNo: page,
          lastPageNo: donationData?.pager.totalPages || 0,
          onPageChange: setPage
        }} /> : <div className={S.empty_wrapper}>
              <Empty emptyItem={t('manage:zemHistoryEmpty')} useCustomMessage image={{
            url: '/images/light/donations/empty_zem-gray400.svg',
            width: 125,
            height: 125
          }} />
            </div>}
        </div>
      </div>
    </section>;
};